import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { UserRun } from '../../../../Models/User/UserRun';
import StreamSelector from '../../../../Modules/Redux/Pages/Stream/StreamSelector';
import { Optional } from '../../../../Utils/Types';
import { EmptyView } from '../../Components/EmptyView/EmptyView';
import { PageLayout } from '../../Components/PageLayout/PageLayout';
import { PageSection } from '../../Components/PageSection/PageSection';
import { PrimaryButton } from '../../Components/PrimaryButton/PrimaryButton';
import { StreamPageRun } from './Run/StreamPageRun';
import { StreamPageVideoHeader } from './Video/StreamPageVideoHeader';

export const StreamPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const run: Optional<UserRun> = useSelector(StreamSelector.currentUserRun);

  function selectMoonList(): void {
    navigate('/moon/list');
  }

  return (
    <div>
      <StreamPageVideoHeader />

      {run ? (
        <StreamPageRun run={run} />
      ) : (
        <PageLayout>
          <PageSection>
            <div className="mt-10">
              <EmptyView title="No run" description="Select a moon list to start a run.">
                <PrimaryButton title="Browse moon lists" onClick={selectMoonList} />
              </EmptyView>
            </div>
          </PageSection>
        </PageLayout>
      )}
    </div>
  );
};
